<span kltNegativeFormatter [value]="value">
  {{ value | localePercentage: decimalPoints : locale | negativeFormatter
  }}<ng-content></ng-content>
</span>
